(function($) {

  Drupal.behaviors.product_sku_single_lists = {
    attach: function(context, settings) {

      $.fn.equalHeights = function(px) {
        $(this).each(function() {
          var currentTallest = 0;
          $(this).children().each(function(i) {
            if ($(this).height() > currentTallest) { currentTallest = $(this).height(); }
          });
          if (!px && Number.prototype.pxToEm) currentTallest = currentTallest.pxToEm(); //use ems unless px is specified
          $(this).children().css({'min-height': currentTallest});
        });
        return this;
      };

      // estee edit articles specific
      $('.ee-article-products__list .clearfix .slick-list').equalHeights();

      $('.ee-article-products__list .clearfix').slick({
        infinite: false,
        slidesToShow: 3,
        responsive: [
          {
            breakpoint: 900,
            settings: {
              infinite: false,
              slidesToShow: 2
            }
          },
          {
            breakpoint: 650,
            settings: {
              infinite: false,
              slidesToShow: 1
            }
          }
        ]
      });

      // if we have product data
      // fix up the swatches for multi-shades
      if(page_data['list_skus'] !== undefined) {

        $shadegroup = $('.sku-brief-editorial__shade');
        $shadegroup.each(function() {

          var shadeHex = $(this).data('product-hexlist');
          // explode
          var shadeHex = shadeHex.split(',');
          //sort swathes
          var swatchType, hexValue1, hexValue2, hexValue3, hexValue4, hexValue5;

          console.log(shadeHex.length);

          if (shadeHex.length == 1) {
            swatchType = 'swatches--single';
            hexValue1 = shadeHex[0];
          } else if(shadeHex.length == 2) {
            swatchType = 'swatches--duo';
            hexValue1 = shadeHex[0];
            hexValue2 = shadeHex[1];
          } else if(shadeHex.length == 3) {
            swatchType = 'swatches--trio';
            hexValue1 = shadeHex[0];
            hexValue2 = shadeHex[1];
            hexValue3 = shadeHex[2];
          } else if(shadeHex.length == 4){
            swatchType = 'swatches--quad';
            hexValue1 = shadeHex[0];
            hexValue2 = shadeHex[1];
            hexValue3 = shadeHex[2];
            hexValue4 = shadeHex[3];
          } else if(shadeHex.length == 5) {
            swatchType = 'swatches--quint';
            hexValue1 = shadeHex[0];
            hexValue2 = shadeHex[1];
            hexValue3 = shadeHex[2];
            hexValue4 = shadeHex[3];
            hexValue5 = shadeHex[4];
          }

          $swatchWrap = $(this).find('.sku-brief-editorial__swatch-container');
          $swatchContainer = $(this).find('.swatch__container');
          $swatchWrap.addClass(swatchType);

          for(var i=0; i<shadeHex.length; i++){
            var $swatchDiv = $('<div/>', {
              'class': 'swatch--'+(i+1),
              'style': 'background-color:'+shadeHex[i]
            });
            $swatchContainer.append($swatchDiv);
          }

        });

      } // swatches

    } // attach
  };

})(jQuery);
